import { createActions } from 'reduxsauce';
const { Types, Creators } = createActions({
  setKnowledgeBase: ['knowledgeBase'],
  setCategory: ['category'],
  getKnowledgeBaseAndCategoryFilter: ['params'],
  getKnowledgeBaseAndCategoryFilterSuccess: ['kbAndCategoryFilter'],
  searchAllKnowledgeResult: ['params'],
  searchAllKnowledgeResultSuccess: ['knowledgeSearchResult'],
  searchAllKnowledgeResultFail: [],
  setKbListId: ['kbListId'],
});
export const SupportSearchTypes = Types;
export default Creators;
